import { render, staticRenderFns } from "./Purpose.vue?vue&type=template&id=6235d2da&scoped=true&"
import script from "./Purpose.vue?vue&type=script&lang=js&"
export * from "./Purpose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235d2da",
  null
  
)

export default component.exports